<!--  -->
<template>
<div class='container'>
    <div class="home">
        <div class="top-box">
            <div class="flexrbc">
                <div class="flexr0c">
                    <div class="title-label"></div>
                    <div class="title">常用车辆管理</div>
                </div>
                <div class="flexrbc">
                    <Input v-model="searchText" placeholder="请输入您要搜索的内容" style="width: auto" @on-blur="getList(1)" @on-enter="getList(1)">
                    <Icon type="ios-search" slot="suffix" />
                    </Input>
                </div>
            </div>
        </div>
        <div class="search-box flexr0c">
            <Input v-on-clickaway="hideCarList" v-model="carId" placeholder="请输入车牌号码或车辆编号" style="width: 280px" @on-keyup="throttle" ref="input"></Input>

            <div class="fuzzy-box" v-show="state&&dataList.length!=0">
                <div class="option">
                    <div class="flexr0c top">
                        <div class="car-licence">车牌号码</div>
                        <div class="car-id">车辆编号</div>
                    </div>
                    <div class="option-list">
                        <div class="flexr0c option-item" v-for="(item,index) in dataList" :key="index" @click="chooseCar(item.state,index,item.isAdd)" :class="{'gray':item.state==1}">
                            <div class="car-licence">{{item.licence}}</div>
                            <div class="car-id2">{{item.carId}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="add-car" @click="addCar">添加车辆</div>
            <div class="tips" v-if="notExist">提示：添加车辆信息不存在</div>
            <div class="tips" v-if="isAdd">提示：该车辆已是常用车辆</div>
        </div>
        <div class="content">
            <div class="table">
                <Table max-height="" :loading="loading1" border stripe :columns="tableHead" :data="tableData">
                    <template slot-scope="{ row }" slot="plateNum">
                        <div :class="row.lockFlag=='正常'?'normal':'blacklist'">{{ row.plateNum }}</div>
                    </template>
                    <template slot-scope="{ row }" slot="truckCode">
                        <div :class="row.lockFlag=='正常'?'normal':'blacklist'">{{ row.truckCode }}</div>
                    </template>
                    <template slot-scope="{ row }" slot="truckType">
                        <div :class="row.lockFlag=='正常'?'normal':'blacklist'">{{ row.truckType }}</div>
                    </template>
                    <template slot-scope="{ row }" slot="avgWeight">
                        <div :class="row.lockFlag=='正常'?'normal':'blacklist'">{{ row.avgWeight }}</div>
                    </template>
                    <template slot-scope="{ row }" slot="lockFlag">
                        <div :class="row.lockFlag=='正常'?'normal':'blacklist'">{{ row.lockFlag }}</div>
                    </template>
                    <template class="flexr0c" slot-scope="{ row, index }" slot="action">
                        <div class="flexr0c">
                            <div class="edit flexr0c" @click="del(index)">
                                <div class="iconfont">&#xe603;</div>
                                <div class="item">删除</div>
                            </div>
                        </div>
                    </template>
                </Table>
                <div style="margin: 10px;overflow: hidden">
                    <div style="float: right;">
                        <Page :total="total" :current="1" :page-size="pageSize" @on-change="changePage" show-elevator show-total></Page>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="mask" v-if="model1||model2">
        <div v-if="model1" class="pop-box">
            <div class="top flexrcc">
                <div class="title">提示</div>
                <img @click="model1=false" src="../../assets/imgs/home/close.png" alt />
            </div>
            <div class="success flexrcc">
                <img src="../../assets/imgs/register/success.png" alt="">
                <div class="success-tips">添加车辆成功！</div>
            </div>
        </div>
        <div v-if="model2" class="pop-box">
            <div class="top flexrcc">
                <div class="title">提示</div>
                <img @click="model2=false" src="../../assets/imgs/home/close.png" alt />
            </div>
            <div class="content flexccc">
                确定删除此常用车辆吗？
            </div>
            <div class="bottom flexrcc">
                <div class="save" @click="save">确定</div>
                <div class="cancel" @click="model2=false">取消</div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name:"carManage",
    components: {},
    data() {
        return {
            total: 0,
            carId: "",
            index: -1,
            searchText: "",
            loading1: false,
            pageSize: 12,
            notExist: false,
            model1: false,
            model2: false,
            state: false,
            statu: true,
            isAdd: false, //是否已添加到常用车辆里
            dataList: [],
            list: [],
            tableHead: [{
                    title: "车牌号码",
                    slot: "plateNum",
                    // width: 120,
                    resizable: true,
                },
                {
                    title: "车辆编号",
                    slot: "truckCode",
                    // width: 140,
                    resizable: true,
                },
                {
                    title: "车辆类型",
                    slot: "truckType",
                    // width: 150,
                    resizable: true,
                },
                {
                    title: "车辆净重(吨)",
                    slot: "avgWeight",
                    // width: 150,
                    resizable: true,
                },
                {
                    title: "车辆状态",
                    slot: "lockFlag",
                    // width: 150,
                    resizable: true,
                },
                {
                    title: "操作",
                    slot: "action",
                    // width: 140,
                    resizable: true,
                },
            ],
            tableData: [],
        };
    },
    methods: {
        changePage(page) {
            this.getPage(page);
        },
        del(index) {
            this.index = index;
            this.model2 = true;
        },
        save() {
            var session = JSON.parse(localStorage["session"]);
            let data = {
                sessionId: session.sessionId,
                modeCode: "NJqXONc9W4rQuuQdxApwUHkqOL3uTTRe",
                id: this.tableData[this.index].id,
            };
            this.$http.post(data).then((res) => {
                if (res.code == 1) {
                    this.tableData.splice(this.index, 1);
                } else {
                    this.$Message['error']({
                        background: true,
                        content: res.msg
                    });
                }
            });
            this.model2 = false;
        },
        chooseCar(state, index, isAdd) {
            if (state == 1) {
                return;
            }
            if (isAdd == 1) {
                this.isAdd = true;
            }
            this.carId = this.dataList[index].licence;
            this.state = false;
        },
        throttle() {
            if(this.carId.length<3){
                this.dataList=[];
                return;
            }
            this.isAdd = false;
            var that = this;
            if (!that.statu) {
                return;
            }
            that.statu = false;
            setTimeout(function () {
                that.getAllList();
                that.statu = true;
            }, 500);
        },
        //点击页面空白部分隐藏模糊查询下拉框
        hideCarList() {
            this.dataList = [];
        },
        getList(index) {
            var session = JSON.parse(localStorage["session"]);
            let data = {
                sessionId: session.sessionId,
                modeCode: "Ilndp2lKoDeTqiwhGyPsnHzl4KuK5JRM",
                userId: session.userId,
                pageIndex: index,
                pageSize: this.pageSize,
            };
            this.searchText ? data.keyword = this.searchText : data;
            this.$http.post(data).then((res) => {
                if (res.code == 1) {
                    res.data.list.forEach((item) => {
                        item.lockFlag == 0 ? item.lockFlag = "正常" : item.lockFlag = "黑名单";
                    })
                    this.total = res.data.count;
                    this.tableData = res.data.list;
                } else {
                    this.$Message['error']({
                        background: true,
                        content: res.msg
                    });
                }
            });
        },
        getAllList() {
            this.dataList = []
            var session = JSON.parse(localStorage["session"]);
            let data = {
                sessionId: session.sessionId,
                modeCode: "dbDzzOte6qzHNWfJggWa9b1djiplSTOe",
                userId: session.userId,
                keyword: this.carId
            };
            this.$http.post(data).then((res) => {
                if (res.code == 1) {
                    res.data.forEach((item) => {
                        let obj = {}
                        obj.carId = item.truckCode;
                        obj.licence = item.plateNum;
                        obj.state = item.lockFlag;
                        obj.isAdd = item.isCommonCar;
                        this.dataList.push(obj);
                    })
                    if (this.carId.length > 0) {
                        this.state = true;
                    } else {
                        this.state = false;
                    }
                } else {
                    this.$Message['error']({
                        background: true,
                        content: res.msg
                    });
                }
            });
        },
        addCar() {
            if (this.isAdd) {
                return;
            }
            var session = JSON.parse(localStorage["session"]);
            let data = {
                sessionId: session.sessionId,
                userId: session.userId,
                modeCode: "S6DC4yxFk3P71XPwE0pc3OTyEY3JeHEO",
                plateNum: this.carId
            };
            this.$http.post(data).then((res) => {
                if (res.code == 1) {
                    this.model1 = true;
                    this.carId = '';
                    this.state = false;
                    this.getList(1);
                } else {
                    this.$Message['error']({
                        background: true,
                        content: res.msg
                    });
                }
            });
        },
    },
    created() {
        this.getList(1);
    },
}
</script>

<style lang="less" scoped>
.container {
    width: 980px;
    text-align: center;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    margin-left: 20px;
    background: #f2f3f5;

    .home {
        .top-box {
            background-image: linear-gradient(180deg, #ffffff 0%, #e8e9ea 100%);
            border-radius: 10px 10px 0 0;
            width: 100%;
            height: 40px;

            /deep/.ivu-input-with-suffix {
                border-radius: 15px;
            }

            &>div {
                height: 100%;
                width: 928px;
                margin: 0 auto;
            }

            .title-label {
                width: 4px;
                height: 14px;
                background: #2c59c3;
            }

            .title {
                font-family: PingFangSC-Semibold;
                font-size: 16px;
                color: #2c59c3;
                letter-spacing: 0.4px;
                margin-left: 6px;
            }

            .addOrg {
                width: 80px;
                height: 30px;
                background-image: linear-gradient(180deg, #F5515F 0%, #9F041B 100%);
                border: 1px solid #D0021B;
                border-radius: 6px;
                cursor: pointer;
                margin-left: 30px;

                &:hover {
                    background-image: linear-gradient(180deg, #FF7D89 0%, #B4051F 100%);
                    border: 1px solid #AF1228;
                }

                img {
                    width: 14px;
                    height: 14px;
                    margin-right: 5px;
                }

                .btn {
                    font-family: PingFangSC-Regular;
                    font-size: 14px;
                    color: #ffffff;
                    letter-spacing: 0.35px;

                }
            }
        }

        .search-box {
            height: 74px;

            /deep/.ivu-input {
                height: 38px;
                border: 1px solid #CCD1DD;
                box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.17);
                border-radius: 8px;
                margin-left: 26px;
                font-size: 14px;
                padding: 0 24px;
            }

            .fuzzy-box {
                position: relative;
                z-index: 5;

                .option {
                    width: 240px;
                    border-radius: 10px;
                    position: absolute;
                    top: 20px;
                    left: -254px;
                    box-shadow: 0 14px 30px 0 rgba(0, 0, 0, 0.14);

                    .top {
                        height: 30px;
                        line-height: 30px;
                        background-image: linear-gradient(180deg, #FFFFFF 0%, #E8E9EA 100%);
                        border-radius: 10px 10px 0 0;

                    }

                    .car-licence {
                        padding-left: 18px;
                        width: 120px;
                        text-align: left;
                    }

                    .car-id {
                        padding-left: 18px;
                        border-left: 1px solid #dadada;
                    }

                    .option-list {

                        // height: 200px;
                        // overflow: auto;
                        // border-radius: 0 0 10px 10px;

                        .option-item {
                            height: 40px;
                            line-height: 40px;
                            background: #fff;
                            color: #999;
                            border-bottom: 1px solid #DADADA;
                            cursor: pointer;

                            &:hover {
                                background: #FAFAFA;
                                color: #4A4A4A;
                            }

                            &:last-child {
                                border-radius: 0 0 10px 10px;
                            }
                        }

                        .option-item.gray {
                            background: #e8e9ea;
                        }

                        .car-id2 {
                            padding-left: 18px;
                        }

                    }
                }
            }

            .add-car {
                width: 110px;
                height: 38px;
                line-height: 38px;
                background-image: linear-gradient(180deg, #B4EC51 0%, #429321 100%);
                border: 1px solid #4C9B25;
                border-radius: 6px;
                font-family: PingFangSC-Semibold;
                font-size: 14px;
                color: #FFFFFF;
                letter-spacing: 0.35px;
                text-align: center;
                z-index: 2;
                cursor: pointer;

                &:hover {
                    background-image: linear-gradient(180deg, #C4FF5B 0%, #4AA824 100%);
                }
            }

            .tips {
                margin-left: 12px;
                font-family: PingFangSC-Regular;
                font-size: 12px;
                color: #AF2534;
            }

        }

        .content {
            background: #fff;
            min-height: 775px;
            width: 100%;
            // box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.10);
            border-radius: 10px;
            overflow: auto;

            .table {
                width: 928px;
                margin: 25px auto;

                .delete {
                    margin-left: 14px;
                }

                .edit,
                .delete {
                    color: #4a4a4a;
                }

                .edit:hover,
                .delete:hover {
                    color: #4a90e2 !important;
                    cursor: pointer;
                }

                .item {
                    margin-left: 4px;
                    font-family: PingFangSC-Regular;
                    font-size: 14px;
                    letter-spacing: 0;
                }

                .normal {
                    color: #252A37 !important;
                }

                .blacklist {
                    color: #9B9B9B !important;
                }

            }
        }
    }

    .mask {
        width: 100vw;
        height: 100vh;
        background: rgba(0, 0, 0, 0.6);
        position: fixed;
        top: 0;
        left: 0;
        z-index: 10;

        .pop-box {
            width: 480px;
            height: 282px;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            z-index: 2;

            .top {
                width: 100%;
                height: 46px;
                background-image: linear-gradient(180deg, #5792e3 0%, #2c59c3 100%);
                border-radius: 10px 10px 0 0;

                .title {
                    font-family: PingFangSC-Semibold;
                    font-size: 18px;
                    color: #ffffff;
                    letter-spacing: 0.34px;
                }

                img {
                    position: absolute;
                    float: right;
                    width: 16px;
                    height: 16px;
                    right: 15px;
                    cursor: pointer;
                }
            }

            .success {
                height: 236px;
                background-color: #fff;
                border-radius: 0 0 10px 10px;

                img {
                    width: 60px;
                    height: 60px;
                    margin-right: 18px;
                }

                .success-tips {
                    font-family: PingFangSC-Medium;
                    font-size: 24px;
                    color: #4A4A4A;
                    letter-spacing: 0.45px;
                }
            }

            .content {
                width: 100%;
                height: 186px;
                background-color: #ffffff;
                font-family: PingFangSC-Medium;
                font-size: 16px;
                color: #4A4A4A;
                letter-spacing: 0;
            }

            .bottom {
                // transform: scaleY(-1);
                background: #f5f5f5;
                border-radius: 0 0 10px 10px;
                height: 50px;

                .cancel {
                    width: 138px;
                    height: 30px;
                    line-height: 30px;
                    background-image: linear-gradient(180deg,
                            rgba(255, 255, 255, 0.97) 0%,
                            rgba(251, 251, 251, 0.98) 37%,
                            #f5f5f5 100%);
                    border: 1px solid #cacaca;
                    border-radius: 4px;
                    font-family: PingFangSC-Medium;
                    font-size: 14px;
                    color: #000000;
                    letter-spacing: 0;
                    margin-left: 16px;
                    text-align: center;
                    cursor: pointer;

                    &:hover {
                        background-image: linear-gradient(180deg, rgba(255, 255, 255, 0.97) 0%, rgba(251, 251, 251, 0.98) 37%, #E9E9E9 100%);
                    }
                }

                .save {
                    width: 138px;
                    height: 30px;
                    line-height: 30px;
                    background-image: linear-gradient(180deg, #478ee9 0%, #2255ce 100%);
                    border: 1px solid #285ed3;
                    border-radius: 4px;
                    font-family: PingFangSC-Medium;
                    font-size: 14px;
                    color: #ffffff;
                    letter-spacing: 0;
                    text-align: center;
                    cursor: pointer;

                    &:hover {
                        background-image: linear-gradient(180deg, #5295F5 0%, #2559D1 99%);
                    }
                }
            }
        }
    }
}
</style>
